import Store from "@/store/index.js";
import axios from "axios";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
const domain = Store.state.domain;

export default {
    async obtenerMovimientosValider(vm) {
        var formData = new FormData();
        axios.post(`${domain.domainNameForApi}Lideres/obtenerMovimientosValider`, formData).then((response) => {
            vm.movimientosArray = response.data;
        });
    },
    async obtenerLideresTodos() {
        let response = await axios.post(`${domain.domainNameForApi}Lideres/obtenerTablaLideresMainTodos`);
        return response.data;
    },
    async obtenerTiposMovimiento(vm, val) {
        var formData = new FormData();
        formData.append("nrreporte", vm.displayInputs.nrreporte);
        formData.append("svindice", vm.displayInputs.svindice);
        formData.append("cetipo", val);
        axios.post(`${domain.domainNameForApi}Lideres/obtenerTiposMovimiento`, formData).then((response) => {
            vm.datos.conceptoSelected = null;
            if (response.data.length > 0) {
                vm.datos.conceptoSelected = response.data[0];
            }
            vm.conceptoArray = response.data;

        });
    },
    async obtenerlistadoCorralonProv(vm) {
        var formData = new FormData();
        formData.append("nrreporte", vm.displayInputs.nrreporte);
        formData.append("svindice", vm.displayInputs.svindice);
        axios.post(`${domain.domainNameForApi}Lideres/obtenerlistadoCorralonProv`, formData).then((response) => {
            vm.corralonArray = response.data;
        });
    },
    async validaposibleconclusion(vm) {
        var formData = new FormData();
        formData.append("nrreporte", vm.displayInputs.nrreporte);
        formData.append("svindice", vm.displayInputs.svindice);
        let response = await axios.post(`${domain.domainNameForApi}Lideres/validaposibleconclusion`, formData);
        return response.data;
    },

    async valFirmaElectronica(reporte, firma, proceso) {
        var formData = new FormData();
        formData.append("usfirma", firma);
        formData.append("nrreporte", reporte.nrreporte);
        formData.append("svindice", reporte.svindice);
        formData.append("proceso", proceso);
        return axios.post(`${domain.domainNameForApi}Lideres/ValFirmaElectronica`, formData).then((response) => response.data);
    },

    async validaReporteCancelado(vm) {
        var formData = new FormData();
        formData.append("nrreporte", vm.displayInputs.nrreporte);
        formData.append("svindice", vm.displayInputs.svindice);
        let response = await axios.post(`${domain.domainNameForApi}Lideres/validaReporteCancelado`, formData);
        return response.data;
    },
    async verificaLlamadas(vm) {
        var formData = new FormData();
        formData.append("nrreporte", vm.displayInputs.nrreporte);
        formData.append("svindice", vm.displayInputs.svindice);
        let response = await axios.post(`${domain.domainNameForApi}Lideres/verificaLlamadas`, formData);
        return response.data;
    },

    async guardarMovtos(vm) {
        var formData = new FormData();
        formData.append("nrreporte", vm.datos.nrreporte);
        formData.append("svindice", vm.datos.svindice);
        formData.append("aiclave", vm.datos.aiclave);
        formData.append("ceclave", vm.datos.conceptoSelected.value);
        formData.append("exobs", vm.datos.observaciones);
        formData.append("esid", vm.datos.esid);
        formData.append("respuesta", vm.datos.respuesta);
        formData.append("corralon", vm.datos.tiporespuesta);
        formData.append("mtclave", 0);
        formData.append("sumRecup", -1);
        formData.append("prclaveCO", vm.datos.corralonSelected);
        formData.append("fecha", vm.datos.fecha);
        formData.append("tmclave", vm.datos.tmclave);

        let response = await axios.post(`${domain.domainNameForApi}Lideres/AgregarMovimiento`, formData);
        return response.data;
    },


    async DatosPantallaAjustador(datos) {
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        let response = await axios.post(`${domain.domainNameForApi}Lideres/DatosPantallaAjustador`, formData);
        return response.data;
    },

    async DatosPantallaNA(datos) {
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        let response = await axios.post(`${domain.domainNameForApi}Lideres/DatosPantallaNA`, formData);
        return response.data;
    },



    async ObtenerLideresActivos(vm) {
        let response = await axios.post(`${domain.domainNameForApi}Lideres/ObtenerLideresActivos`);
        vm.lideres.opcionesLideres = response.data;
    },
    async GuardarReasignacion(datos) {
        let response = await axios.post(`${domain.domainNameForApi}Lideres/GuardarReasignacion`, datos);
        return response.data;
    },
    async editarAsegurado(vm) {
        var formData = new FormData();
        formData.append("nrreporte", vm.displayInputs.nrreporte);
        formData.append("svindice", vm.displayInputs.svindice);
        formData.append("datos", JSON.stringify(vm.datos));

        return axios
            .post(`${domain.domainNameForApi}Lideres/EditarAsegurado`, formData)
            .then((response) => response.data);
    },

    async editarNA(vm) {

        var formData = new FormData();
        formData.append("nrreporte", vm.displayInputs.nrreporte);
        formData.append("svindice", vm.displayInputs.svindice);
        formData.append("datos", JSON.stringify(vm.datos));

        return axios
            .post(`${domain.domainNameForApi}Lideres/EditarNA`, formData)
            .then((response) => response.data);
    },

    async editarAB(vm) {

        var formData = new FormData();
        formData.append("nrreporte", vm.displayInputs.nrreporte);
        formData.append("svindice", vm.displayInputs.svindice);
        formData.append("datos", JSON.stringify(vm.datos));

        return axios
            .post(`${domain.domainNameForApi}Lideres/EditarAB`, formData)
            .then((response) => response.data);
    },

    async obtenerDatosAsegurado(vm) {
        var formData = new FormData();
        formData.append("nrreporte", vm.displayInputs.nrreporte);
        formData.append("svindice", vm.displayInputs.svindice);

        let response = await axios.post(
            `${domain.domainNameForApi}Lideres/obtenerDatosAsegurado`,
            formData
        );

        return response.data;
    },


    async ObtenerActoresHorario(datos) {
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);

        let response = await axios.post(
            `${domain.domainNameForApi}Lideres/ObtenerActoresHorario`,
            formData
        );

        return response.data;
    },
    async AyudaLideres() {
        let response = await axios.post(`${domain.domainNameForApi}Lideres/AyudaLideres`);
        return response.data;
    },

    async ValidarHorarioActor(datos) {
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);

        let response = await axios.post(
            `${domain.domainNameForApi}Lideres/ValidarHorarioActor`,
            formData
        );

        return response.data;
    },

    async InsertarActoresHorario(datos, staid, hlhorario) {
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        formData.append("staid", staid);
        formData.append("hlhorario", hlhorario);

        let response = await axios.post(
            `${domain.domainNameForApi}Lideres/InsertarActoresHorario`,
            formData
        );

        return response.data;
    },

    async obtenerPasadaAlto(vm) {
        var formData = new FormData();
        formData.append("pdatipo", "A");
        formData.append("pdaactivo", 1);
        axios
            .post(`${domain.domainNameForApi}Lideres/ObtenerPasadaAlto`, formData)
            .then((response) => {
                vm.opcionesPasadaAlto = response.data;
            });
    },


    async obtenerPasadaAltoNA(vm) {
        var formData = new FormData();
        formData.append("pdatipo", "A");
        formData.append("pdaactivo", 1);
        axios
            .post(`${domain.domainNameForApi}Lideres/obtenerPasadaAltoNA`, formData)
            .then((response) => {
                vm.opcionesPasadaAlto = response.data;
            });
    },

    async ListardatoscontactoAB(prclave) {
        var formData = new FormData();
        formData.append("prclave", prclave);
        formData.append("pdaactivo", 1);

        let response = await axios.post(
            `${domain.domainNameForApi}Lideres/ListardatoscontactoAB`,
            formData
        );

        return response.data;


    },
    async ObtenerEstatusLider() {
        let response = await axios.post(`${domain.domainNameForApi}Lideres/ObtenerEstatusLider`);
        return response.data[0];
    },
    async ActivarLideres(ldestatus) {
        var formData = new FormData();
        formData.append("ldestatus", ldestatus);
        let response = await axios.post(`${domain.domainNameForApi}Lideres/ActivarLideres`, formData);
        return response.data;
    },
    async EliminarMovimiento(data) {
        let response = await axios.post(`${domain.domainNameForApi}Movimientos/EliminarMovimiento`, data);
        return response.data[0];
    },

    /*CRITERIO DEL LIDER*/
    async DatosCriterioLider(datos) {
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        let response = await axios.post(`${domain.domainNameForApi}Lideres/DatosCriterioLider`, formData);
        return response.data[0];
    },
    async GuardarCriterioLider(reporte, indice, sacriteriolider, sadesclider) {
        var formData = new FormData();
        formData.append("nrreporte", reporte);
        formData.append("svindice", indice);
        formData.append("sacriteriolider", sacriteriolider);
        formData.append("sadesclider", sadesclider);
        let response = await axios.post(`${domain.domainNameForApi}Lideres/GuardarCriterioLider`, formData);
        return response.data;
    },
    async ObtenerCatalogoIndicio(vm) {
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}ReporteGeneral/ObtenerCatalogoIndicio`);
        vm.datosIndicios = response.data;
    },
    async ObtenerIndicios(reporte) {
        var datos = new FormData();
        datos.append("nrreporte", reporte.nrreporte);
        datos.append("svindice", reporte.svindice);
        let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/ObtenerIndicios`, datos);
        return response.data;
    },
    async GuardarIndicios(reporte, indicios) {
        var datos = new FormData();
        datos.append("nrreporte", reporte.nrreporte);
        datos.append("svindice", reporte.svindice);
        datos.append("indicios", indicios);
        let response = await axios.post(`${domain.domainNameForApi}Lideres/GuardarIndicios`, datos);
        return response.data;
    },
    async CatalogoDatosPrueba(vm) {
        let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/CatalogoDatosPrueba`);
        vm.datosPrueba = response.data.data;
    },
    async ObtenerDatosPruebaReporteInforme(reporte) {
        var datos = new FormData();
        datos.append("nrreporte", reporte.nrreporte);
        datos.append("svindice", reporte.svindice);
        let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/ObtenerDatosPruebaReporteInforme`, datos);
        return response.data;
    },
    async CatalogoOpcionTecnica(vm, cdpclave) {
        var datos = new FormData();
        datos.append("cdpclave", cdpclave);
        let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/CatalogoOpcionTecnica`, datos);
        vm.opcionTec = response.data.data;
    },
    async GuardarDatosPrueba(reporte, seleccion, opiontecnica) {
        var datos = new FormData();
        datos.append("nrreporte", reporte.nrreporte);
        datos.append("svindice", reporte.svindice);
        datos.append("seleccion", seleccion);
        datos.append("opiontecnica", opiontecnica);
        let response = await axios.post(`${domain.domainNameForApi}Lideres/GuardarDatosPrueba`, datos);
        return response.data;
    },
    async CatalogoRecuperaciones(vm) {
        let response = await axios.post(`${domain.domainNameForApi}Lideres/CatalogoRecuperaciones`);
        vm.recuperaciones = response.data;
    },
    async ValidacionRecuperacion(reporte, chSelected) {
        var datos = new FormData();
        datos.append("nrreporte", reporte.nrreporte);
        datos.append("svindice", reporte.svindice);
        datos.append("chSelected", chSelected);
        let response = await axios.post(`${domain.domainNameForApi}Lideres/ValidacionRecuperacion`, datos);
        return response.data;
    },
    async AgregarMovimientosRecuperacion(reporte, cadena, sumRecup) {
        var datos = new FormData();
        datos.append("nrreporte", reporte.nrreporte);
        datos.append("svindice", reporte.svindice);
        datos.append("cadena", cadena);
        datos.append("sumRecup", sumRecup);
        let response = await axios.post(`${domain.domainNameForApi}Lideres/AgregarMovimientosRecuperacion`, datos);
        return response.data;
    },
    async ValidarPrecierre(reporte) {
        var datos = new FormData();
        datos.append("nrreporte", reporte.nrreporte);
        datos.append("svindice", reporte.svindice);
        let response = await axios.post(`${domain.domainNameForApi}Lideres/ValidarPrecierre`, datos);
        return response.data[0];
    },
    async OpcionesPrecierre(vm, reporte) {
        var datos = new FormData();
        datos.append("nrreporte", reporte.nrreporte);
        datos.append("svindice", reporte.svindice);
        let response = await axios.post(`${domain.domainNameForApi}Lideres/OpcionesPrecierre`, datos);
        vm.opcPrecierre = response.data;
    },
    async ValConclusionAdm(reporte) {
        var datos = new FormData();
        datos.append("nrreporte", reporte.nrreporte);
        datos.append("svindice", reporte.svindice);
        let response = await axios.post(`${domain.domainNameForApi}Lideres/ValConclusionAdm`, datos);
        return response.data;
    },
    async ValidacionPrecierre(reporte, opciones) {
        var datos = new FormData();
        datos.append("nrreporte", reporte.nrreporte);
        datos.append("svindice", reporte.svindice);
        datos.append("opciones", opciones);

        let response = await axios.post(`${domain.domainNameForApi}Lideres/ValidacionPrecierre`, datos);
        return response.data[0];
    },
    async ObtenerDatosPreCierre(reporte) {
        var datos = new FormData();
        datos.append("nrreporte", reporte.nrreporte);
        datos.append("svindice", reporte.svindice);
        let response = await axios.post(`${domain.domainNameForApi}Lideres/ObtenerDatosPreCierre`, datos);
        return response.data[0];
    },
    async ObtenerPosibleConclusion(reporte) {
        var datos = new FormData();
        datos.append("nrreporte", reporte.nrreporte);
        datos.append("svindice", reporte.svindice);
        let response = await axios.post(`${domain.domainNameForApi}Lideres/ObtenerPosibleConclusion`, datos);
        return response.data[0];
    },
    async GuardarPrecierre(reporte, ceclave, opciones, obs, conclusionadmin, firma, fecha, esid) {
        var datos = new FormData();
        datos.append("nrreporte", reporte.nrreporte);
        datos.append("svindice", reporte.svindice);
        datos.append("aiclave", reporte.aiclave);
        datos.append("ceclave", ceclave);
        datos.append("opciones", opciones);
        datos.append("obs", obs);
        datos.append("conclusionadmin", conclusionadmin);
        datos.append("firma", firma);
        datos.append("fecha", fecha);
        datos.append("esid", esid);
        let response = await axios.post(`${domain.domainNameForApi}Lideres/GuardarPrecierre`, datos);
        return response.data;
    },
    async EncabezadoReporte(reporte) {
        var formData = new FormData();
        formData.append("nrreporte", reporte.nrreporte);
        formData.append("svindice", reporte.svindice);
        formData.append("aiclave", reporte.aiclave);
        let response = await axios.post(`${domain.domainNameForApi}ExpJur/EncabezadoReporte`, formData);
        return response.data[0];
    },
    async SaltarValider(reporte) {
        var formData = new FormData();
        formData.append("nrreporte", reporte.nrreporte);
        formData.append("svindice", reporte.svindice);
        let response = await axios.post(`${domain.domainNameForApi}Lideres/SaltarValider`, formData);
        return response;
    },
    async DatosLider(lduslogin) {
        var formData = new FormData();
        formData.append("Lduslogin", lduslogin);
        let response = await axios.post(`${domain.domainNameForApi}Lideres/DatosLider`, formData);
        return response.data[0];
    },
    async ObtenerTiposCarga() {
        let response = await axios.post(`${domain.domainNameForApi}Lideres/ObtenerTiposCarga`);
        return response.data;
    },
    async ConsultarTipoServicio(nrreporte, svindice, aiclave){
        var formData = new FormData();
        formData.append("nrreporte", nrreporte);
        formData.append("svindice", svindice);
        formData.append("aiclave", aiclave);
        let response = await axios.post(`${domain.domainNameForApi}Lideres/ConsultarServicio`, formData);
        return response.data[0];
      },
    async obtenerFiltros(vm) {
        var formData = new FormData();
        axios.post(`${domain.domainNameForApi}Lideres/obtenerFiltros`, formData).then((response) => {
            vm.itemsFiltros = response.data;
            vm.filter = { text: vm.itemsFiltros[0].text, value: vm.itemsFiltros[0].value };
        });
    },

    async obtenerAseguradoras(vm) {
        axios.post(`${domain.domainNameForApi}Lideres/ObtenerAseguradora`).then(response => {
            vm.aseguradoras = response.data;
        })
    },

    async obtenerEstados(vm) {
        axios.post(`${domain.domainNameForApi}Lideres/ObtenerEstado`).then(response => {
            vm.estados = response.data;
        })
    },
    async obtenerLocalidades(vm) {
        var formData = new FormData();
        formData.append("esclave", vm.estado.esclave);

        let response = await axios.post(`${domain.domainNameForApi}Lideres/ObtenerLocalidades`, formData);
        return response.data;
    },
    async obtenerRelevancia(vm) {
        axios.post(`${domain.domainNameForApi}Lideres/obtenerRelevancia`).then(response => {
            vm.relevancias = response.data;
        })
    },
    async obtenerAsistencias(vm) {
        axios.post(`${domain.domainNameForApi}Lideres/obtenerAsistencias`).then(response => {
            vm.asistencias = response.data;
        })
    },
    async obtenerUsuarios(vm) {
        axios.post(`${domain.domainNameForApi}Lideres/obtenerUsuarios`).then(response => {
            vm.usuarios = response.data;
        })
    }
};
